import * as React from 'react';
import { css } from 'emotion';

interface Props {
  'data-testid'?: string;
}

export const Dashed: React.FunctionComponent<Props> = ({ 'data-testid': dataTestId }) => (
  <span className={classNames.dashed} data-testid={dataTestId}>
    &ndash;&ndash;
  </span>
);

const classNames = {
  dashed: css`
    font-size: 0.8125rem;
    letter-spacing: 1px;
  `,
};
